var _defs, _rect, _rect2, _g, _path, _circle, _g2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTagbooruToolkit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f2b3c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141c28"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    rx: 48,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 510,
    height: 510,
    rx: 47,
    fill: "none",
    stroke: "rgba(255,255,255,0.12)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#7f93ad",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132 110 c-30 0 -30 30 -30 50 v22 c0 14 -8 22 -22 22 c14 0 22 8 22 22 v22 c0 20 0 50 30 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 110 c30 0 30 30 30 50 v22 c0 14 8 22 22 22 c-14 0 -22 8 -22 22 v22 c0 20 0 50 -30 50"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 150 h96 l88 88 l-84 84 l-100 -100 z",
    fill: "#63d1bf"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 208,
    cy: 182,
    r: 14,
    fill: "#101722"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176 322 h160",
    stroke: "#f0b46a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 346 h112",
    stroke: "#9fb3cc"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 404,
    textAnchor: "middle",
    fontFamily: "Montserrat, 'Segoe UI', Arial, sans-serif",
    fontSize: 40,
    fontWeight: 700,
    fill: "#f7f9fd"
  }, "Tagbooru Toolkit")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 444,
    textAnchor: "middle",
    fontFamily: "Consolas, Menlo, monospace",
    fontSize: 18,
    fill: "#7f93ad",
    letterSpacing: 3
  }, "TAG FORMATTER  |  WEB")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagbooruToolkit);
export default __webpack_public_path__ + "static/media/tagbooru-toolkit.a22f4cddc6354de52cf84bdf710d4fc0.svg";
export { ForwardRef as ReactComponent };